/**
 * @fileoverview POST handler for the "/apps/:app_group_id/territories_update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdTerritoriesUpdateArchivedStateCacheKeys } from "./constants";
import type { postTeamsArchivedStateProps, AppsAppGroupIdTerritoriesUpdateArchivedStateResult } from "./types";

export const postTeamsArchivedState = reactQueryMutationAdapter(
  appsAppGroupIdTerritoriesUpdateArchivedStateCacheKeys,
  (props: postTeamsArchivedStateProps): Promise<AppsAppGroupIdTerritoriesUpdateArchivedStateResult> => {
    // manipulate props here as needed { ids, mark_as_archived, undo_identifier }

    return fetch(`/apps/${props.appGroupId}/territories_update_archived_state`, "POST", props);
  }
);
